module.exports = __webpack_public_path__ + "static/media/sence4.f3371eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/sence4.png
// module id = 545
// module chunks = 0